export default "__VITE_ASSET__09369cb0__"